import { apiRoutes } from 'routes';
import FetchHelpers from 'utils/FetchHelpers';

export default {
  index(datasetId) {
    const path = apiRoutes.datasetInitialParametersUserPath(datasetId);
    return FetchHelpers.get(path);
  },
};
